import {t} from "i18next";
import { isScopeThreeVisible } from "../../utils";

export const MEASURES = Object.freeze({
  KWH: t("measures.kwh"),
  LITRES: t("measures.litres"),
  CUBIC_METERS: t("measures.cubicMeters"),
  KG: t("measures.kg"),
  TONNES: t("measures.tonnes"),
  MILES: t("measures.miles")
});

/**
 * @deprecated The database/api also defines names. This duplicates and is rigid
 */
export const CONSUMPTION_ITEMS = Object.freeze({
  GAS: t("organizationQuestionnaire.scope1.inputs.gasConsumptionTitle"),
  GAS_100_MINERAL: t("organizationQuestionnaire.scope1.inputs.gas100MineralConsumptionTitle"),
  DIESEL: t("organizationQuestionnaire.scope1.inputs.dieselConsumptionTitle"),
  LNG: t("organizationQuestionnaire.scope1.inputs.lngConsumptionTitle"),
  BIO_LNG: t("organizationQuestionnaire.scope1.inputs.bioLngConsumptionTitle"),
  ACETYLENE: t("organizationQuestionnaire.scope1.inputs.acetyleneConsumptionTitle"),
  AVIATION_SPIRIT: t("organizationQuestionnaire.scope1.inputs.aviationSpiritTitle"),
  PETROL: t("organizationQuestionnaire.scope1.inputs.petrolTitle"),
  PETROL_100_MINERAL: t("organizationQuestionnaire.scope1.inputs.petrol100MineralConsumptionTitle"),
  PROPANE_GAS: t("organizationQuestionnaire.scope1.inputs.propaneConsumptionTitle"),
  LPG: t("organizationQuestionnaire.scope1.inputs.lpgConsumptionTitle"),
  RED_DIESEL: t("organizationQuestionnaire.scope1.inputs.redDieselConsumption"),
  GAS_OIL: t("organizationQuestionnaire.scope1.inputs.gasOilConsumptionTitle"),
  KEROSENE: t("organizationQuestionnaire.scope1.inputs.keroseneConsumption"),
  BIO_MASS: t("organizationQuestionnaire.scope1.inputs.bioMassConsumption"),
  HVO: t("organizationQuestionnaire.scope1.inputs.hvoConsumption"),
  AVIATION_TURBINE_FUEL: t("organizationQuestionnaire.scope1.inputs.aviationTurbineFuel"),
  DIESEL_SMALL_CAR: t("organizationQuestionnaire.scope1.inputs.dieselSmallCar"),
  DIESEL_MEDIUM_CAR: t("organizationQuestionnaire.scope1.inputs.dieselMediumCar"),
  DIESEL_LARGE_CAR: t("organizationQuestionnaire.scope1.inputs.dieselLargeCar"),
  PETROL_SMALL_CAR: t("organizationQuestionnaire.scope1.inputs.petrolSmallCar"),
  PETROL_MEDIUM_CAR: t("organizationQuestionnaire.scope1.inputs.petrolMediumCar"),
  PETROL_LARGE_CAR: t("organizationQuestionnaire.scope1.inputs.petrolLargeCar"),
  ELECTRICITY_LOCATION_BASED: t("organizationQuestionnaire.scope2.inputs.locationBasedElectricity"),
  ELECTRICITY_MARKET_BASED: t("organizationQuestionnaire.scope2.inputs.marketBasedElectricity"),
  ELECTRICITY_ONSITE_GENERATION: t("organizationQuestionnaire.scope2.inputs.onsiteGenerationElectricity"),
  RENEWABLE_ENERGY_PROCUREMENT: t("organizationQuestionnaire.scope2.inputs.renewableEnergyProcurement"),
  R134A: t("reportsPage.metrics.r134a"),
  R22: t("reportsPage.metrics.r22"),
  R290: t("reportsPage.metrics.r290"),
  R32: t("reportsPage.metrics.r32"),
  R404A: t("reportsPage.metrics.r404a"),
  R407A: t("reportsPage.metrics.r407a"),
  R407C: t("reportsPage.metrics.r407c"),
  R407F: t("reportsPage.metrics.r407f"),
  R410A: t("reportsPage.metrics.r410a"),
  R422D: t("reportsPage.metrics.r422d"),
  R448A: t("reportsPage.metrics.r448a"),
  R449A: t("reportsPage.metrics.r449a"),
  R452A: t("reportsPage.metrics.r452a"),
  R507: t("reportsPage.metrics.r507")
});

/**
 * @deprecated The database/api also defines names. This duplicates and is rigid
 */
export const POWER_SOURCES = Object.freeze({
  GAS: t("reportsPage.metrics.gas"),
  GAS_100_MINERAL: t("reportsPage.metrics.gas100Mineral"),
  DIESEL: t("reportsPage.metrics.diesel"),
  LNG: t("reportsPage.metrics.lng"),
  BIO_LNG: t("reportsPage.metrics.bioLng"),
  ACETYLENE: t("reportsPage.metrics.acetylene"),
  AVIATION_SPIRIT: t("reportsPage.metrics.aviationSpirit"),
  PETROL: t("reportsPage.metrics.petrol"),
  PETROL_100_MINERAL: t("reportsPage.metrics.petrol100Mineral"),
  PROPANE_GAS: t("reportsPage.metrics.propaneGas"),
  LPG: t("reportsPage.metrics.lpg"),
  RED_DIESEL: t("reportsPage.metrics.redDiesel"),
  GAS_OIL: t("reportsPage.metrics.gasOil"),
  KEROSENE: t("reportsPage.metrics.kerosene"),
  BIO_MASS: t("reportsPage.metrics.bioMass"),
  HVO: t("reportsPage.metrics.hvo"),
  AVIATION_TURBINE_FUEL: t("reportsPage.metrics.aviationTurbineFuel"),
  DIESEL_SMALL_CAR: t("organizationQuestionnaire.scope1.inputs.dieselSmallCar"),
  DIESEL_MEDIUM_CAR: t("organizationQuestionnaire.scope1.inputs.dieselMediumCar"),
  DIESEL_LARGE_CAR: t("organizationQuestionnaire.scope1.inputs.dieselLargeCar"),
  PETROL_SMALL_CAR: t("organizationQuestionnaire.scope1.inputs.petrolSmallCar"),
  PETROL_MEDIUM_CAR: t("organizationQuestionnaire.scope1.inputs.petrolMediumCar"),
  PETROL_LARGE_CAR: t("organizationQuestionnaire.scope1.inputs.petrolLargeCar"),
  ELECTRICITY_LOCATION_BASED: t("reportsPage.metrics.locationBasedElectricity"),
  ELECTRICITY_MARKET_BASED: t("reportsPage.metrics.marketBasedElectricity"),
  ELECTRICITY_ONSITE_GENERATION: t("reportsPage.metrics.onsiteGenerationElectricity"),
  RENEWABLE_ENERGY_PROCUREMENT: t("reportsPage.metrics.renewableEnergyProcurement"),
  R134A: t("reportsPage.metrics.r134a"),
  R22: t("reportsPage.metrics.r22"),
  R290: t("reportsPage.metrics.r290"),
  R32: t("reportsPage.metrics.r32"),
  R404A: t("reportsPage.metrics.r404a"),
  R407A: t("reportsPage.metrics.r407a"),
  R407C: t("reportsPage.metrics.r407c"),
  R407F: t("reportsPage.metrics.r407f"),
  R410A: t("reportsPage.metrics.r410a"),
  R422D: t("reportsPage.metrics.r422d"),
  R448A: t("reportsPage.metrics.r448a"),
  R449A: t("reportsPage.metrics.r449a"),
  R452A: t("reportsPage.metrics.r452a"),
  R507: t("reportsPage.metrics.r507")
});

export const mapEmissionsFormDataToApiData = (formData) => {
  const apiData = [];

  formData.forEach(el => {
    apiData.push({
      id: el.id,
      dimensionItems: {
        dimensionOneItem: el.dimensionOneItem ?? null,
        dimensionTwoItem: el.dimensionTwoItem ?? null,
        dimensionThreeItem: el.dimensionThreeItem ?? null,
        dimensionFourItem: el.dimensionFourItem ?? null,
        dimensionFiveItem: el.dimensionFiveItem ?? null
      },
      consumption: {
        value: el.consumptionValue,
        measureId: el.consumptionMeasure
      },
      consumptionTypeId: el.consumptionType
    });
  });

  return apiData;
}

export const mapEmissionsFormDataToElectricityApiData = (formData) => {
  const apiData = [];

  formData.forEach(el => {
    apiData.push({
      id: el.id,
      dimensionItems: {
        dimensionOneItem: el.dimensionOneItem ?? null,
        dimensionTwoItem: el.dimensionTwoItem ?? null,
        dimensionThreeItem: el.dimensionThreeItem ?? null,
        dimensionFourItem: el.dimensionFourItem ?? null,
        dimensionFiveItem: el.dimensionFiveItem ?? null
      },
      consumption: {
        value: el.consumptionValue,
        measureId: el.consumptionMeasure
      },
      electricityType: el.electricityType
    });
  });

  return apiData;
}

export const TAB_TYPES = Object.freeze({
  DIRECT_EMISSIONS: "DIRECT_EMISSIONS",
  INDIRECT_EMISSIONS: "INDIRECT_EMISSIONS",
  CATEGORIES: "CATEGORIES"
});

export const getTabIndexes = (data) => {
  const indexes = {};

  if (data.configurations.directEmissionsShouldBeFilled) {
    indexes[TAB_TYPES.DIRECT_EMISSIONS] = 0;
    if (data.configurations.indirectEmissionsShouldBeFilled) {
      indexes[TAB_TYPES.INDIRECT_EMISSIONS] = 1;
      if (isScopeThreeVisible(data)) {
        indexes[TAB_TYPES.CATEGORIES] = 2;
      }
    } else {
      if (isScopeThreeVisible(data)) {
        indexes[TAB_TYPES.CATEGORIES] = 1;
      }
    }
  } else {
    if (data.configurations.indirectEmissionsShouldBeFilled) {
      indexes[TAB_TYPES.INDIRECT_EMISSIONS] = 0;
      if (isScopeThreeVisible(data)) {
        indexes[TAB_TYPES.CATEGORIES] = 1;
      }
    } else {
      if (isScopeThreeVisible(data)) {
        indexes[TAB_TYPES.CATEGORIES] = 0;
      }
    }
  }

  return indexes;
}